export function isKeyword(segment: string): boolean {
	if (!segment) return false;

	const keywords = [
		"facing",
		"builtuparea",
		"budget",
		"possession",
		"maxage",
		"furnishing",
		"amenities",
		"documents",
		"spaces",
		"floor",
		"floors",
		"rentalvalue",
		"zoom",
		"status",
		"watersources",
		"level",
		"plotfacing",
		"plotarea",
		"subtype",
		"lat",
		"lng",
	];

	return (
		keywords.includes(segment) ||
		segment.includes("bhk") ||
		(segment.includes("bathrooms") && !segment.includes("space_bathrooms")) ||
		segment.includes("balconies") ||
		segment.includes("parkings") ||
		["apartments", "houses", "villas", "plots", "in"].includes(segment)
	);
}
